// Vendors
import { useDispatch, useSelector } from 'react-redux';

// Components
import Icon from '../../Icon/Icon';
import { Trans } from '../../Trans';

// Actions
import { closeLockoutModal } from '../../../reducers/auth/authActions';

// Helpers
import { clearAuthSession } from '../../../reducers/auth/authAuthorizeHelpers';

// Selectors
import { 
  selectLockoutModalOpen,
  selectAppUrl, 
} from '../../../reducers/auth/authSelectors';

// Styles
import './lockout-modal.scss';

const LockoutModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectLockoutModalOpen);
  const appUrl = useSelector(selectAppUrl);

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(closeLockoutModal());
    if (appUrl) {
      clearAuthSession();
      window.location.href = appUrl;
    }
  };

  return (
    <div className="sign-in-locked-modal-backdrop" role="presentation">
      <div
        className="sign-in-locked-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sign-in-locked-modal-title"
        aria-describedby="sign-in-locked-modal-description"
      >
        <button
          type="button"
          className="sign-in-locked-modal-close"
          aria-label="Close account locked dialog"
          onClick={handleClose}
        >
          <span className="sign-in-locked-modal-close-line" />
          <span className="sign-in-locked-modal-close-line sign-in-locked-modal-close-line-2" />
        </button>

        <div className="sign-in-locked-modal-top-accent" aria-hidden="true" />

        <h2 id="sign-in-locked-modal-title" className="sign-in-locked-modal-title">
          <Trans file="auth" id="AccountTemporarilyLocked" />
        </h2>

        <div className="sign-in-locked-modal-illustration" aria-hidden="true">
          <Icon name="errorLockedOut" className="sign-in-locked-modal-illustration-image" />
        </div>

        <p id="sign-in-locked-modal-description" className="sign-in-locked-modal-description">
          <Trans file="auth" id="FourHourLockout" />
        </p>
      </div>
    </div>
  );
};

export default LockoutModal;
